import React, { FC, ReactNode } from 'react';

import Link from '@skippay/core/components/Link';
import Step from '@skippay/core/components/Step';
import Text from '@skippay/core/components/Text';

interface Props {
	warningMessage: ReactNode;
	testId: string;
	confirmMessage: ReactNode;
	onConfirm: () => void;
}

export const ValidationWarning: FC<Props> = (props) => {
	const { onConfirm, confirmMessage, testId, warningMessage } = props;

	return (
		<>
			<Text color="red-500" size="paragraphSmall">
				{warningMessage}
			</Text>
			<Step v xxxs className="d-none d-sm-block" />
			<Step v xxs larger className="d-sm-none" />
			<Text>
				<Link variant="inherit" onClick={onConfirm} testId={testId}>
					{confirmMessage}
				</Link>
			</Text>
			<Step v xxs className="d-sm-none" />
		</>
	);
};
